export const es = {
  // App branding
  appName: 'Hekaya',

  // Navigation
  home: 'Inicio',
  forYou: 'Para ti',
  myList: 'Mi lista',
  profile: 'Perfil',
  userProfile: 'Perfil de usuario',

  // Authentication
  signIn: 'Iniciar sesión',
  signUp: 'Registrarse',
  signOut: 'Cerrar sesión',
  signInWithApple: 'Iniciar sesión con Apple',
  signUpWithApple: 'Registrarse con Apple',
  signInWithGoogle: 'Iniciar sesión con Google',
  signUpWithGoogle: 'Registrarse con Google',
  appleSignInFailed: 'Error al iniciar sesión con Apple. Inténtelo de nuevo.',
  appleAuthExpired: 'Código de Apple caducado',
  appleAuthRetrying: 'Reintentando automáticamente...',
  appleAuthRetryFailed: 'Error al iniciar sesión con Apple. Inténtelo de nuevo.',
  appleAuthMaxRetriesReached: 'Demasiados intentos. Inténtelo de nuevo más tarde.',
  appleSignInCancelled: 'Se canceló el inicio de sesión con Apple.',
  appleAccountAlreadyExists: 'Ya existe una cuenta con este ID de Apple. Por favor, inicie sesión.',
  appleAccountNotFound: 'No se encontró ninguna cuenta con este ID de Apple. Regístrese primero.',
  googleSignInFailed: 'Error al iniciar sesión con Google. Inténtelo de nuevo.',
  googleAuthRetrying: 'Reintentando automáticamente...',
  googleAuthMaxRetriesReached: 'Demasiados intentos. Inténtelo de nuevo más tarde.',
  or: 'o',
  email: 'Correo electrónico',
  emailOrPhone: 'Correo o Teléfono',
  enterEmail: 'Ingrese su correo electrónico',
  enterEmailOrPhone: 'Ingrese su correo o número de teléfono',
  emailOrPhonePlaceholder: 'correo@ejemplo.com o +34612345678',
  signInRequired: 'Inicio de sesión requerido',
  toWatchThisEpisode: 'Para ver este episodio',
  toAddEpisodeToFavorites: 'Para agregar este episodio a tus favoritos',
  pleaseSignInToWatch: 'Por favor inicia sesión para ver este episodio',
  pleaseSignInToAddFavorite: 'Por favor inicia sesión para agregar este episodio a favoritos',
  pleaseSignInToAddSerieFavorite: 'Por favor inicia sesión para agregar esta serie a favoritos',
  pleaseSignInToSubscribe: 'Por favor inicia sesión para suscribirte',
  pleaseSignInToAccessRewards: 'Por favor inicia sesión para acceder a todas las funciones y hacer seguimiento de tus recompensas.',
  subscriptionRequired: 'Suscripción requerida',
  episodeRequiresPremium: 'Este episodio requiere una suscripción premium',

  // Force update
  updateRequired: 'Actualización requerida',
  currentVersion: 'Versión actual',
  requiredVersion: 'Versión requerida',
  updateNow: 'Actualizar ahora',
  appCannotBeUsedWithoutUpdate: 'La aplicación no se puede usar sin actualizar',
  forceUpdateDefaultMessage: 'Hay una nueva versión de la aplicación disponible. Actualiza para continuar usando la aplicación.',

  // Recommended update
  updateAvailable: 'Actualización disponible',
  recommendedVersion: 'Versión recomendada',
  updateButton: 'Actualizar',
  laterButton: 'Más tarde',
  updateWillBeShownAgainIn24Hours: 'Esta actualización se mostrará nuevamente en 24 horas',
  recommendedUpdateMessage: 'Hay una nueva versión de la aplicación disponible con mejoras y nuevas funciones. Te recomendamos actualizar para una mejor experiencia.',

  // Errors
  error: 'Error',
  pleaseFillAllFields: 'Por favor complete todos los campos',
  failedToCreateAccount: 'Error al crear la cuenta',
  invalidCredentials: 'Credenciales inválidas',
  accountDisabled: 'Esta cuenta ha sido deshabilitada',
  emailAlreadyExists: 'Este correo electrónico ya está siendo usado por otra cuenta',
  phoneAlreadyExists: 'Este número de teléfono ya está siendo usado por otra cuenta',
  invalidEmailFormat: 'Por favor ingresa una dirección de correo electrónico válida',
  invalidPhoneFormat: 'Por favor ingresa un número de teléfono válido',
  accountMergeNotSupported: 'Ya existe una cuenta con esta dirección de correo electrónico. Por favor inicia sesión con tu método de inicio de sesión original.',

  // Content
  searchDramas: 'Buscar dramas...',
  noResultsFound: 'No se encontraron resultados para "{query}"',
  searchResultsOne: '1 resultado para "{query}"',
  searchResultsMany: '{count} resultados para "{query}"',
  allSeries: 'Todas las series',
  topCharts: 'Top de series',
  recommendedForYou: 'Recomendado para ti',
  basedOnPreferences: 'Basado en tus preferencias',
  continueWatching: 'Continuar viendo',
  resumeWatching: 'Retomar la visualizacion',
  similarToWatched: 'Similar a lo que has visto',
  trendingSearches: 'Búsquedas populares',
  noSeriesInProgress: 'No hay series en progreso',
  startWatchingToSee: 'Comienza a ver una serie para verla aquí',
  noContentAvailable: 'No hay contenido disponible',
  checkSupabaseConfig: 'Por favor verifica tu configuración de Supabase',

  // Series and episodes
  seasons: 'Temporadas',
  season: 'Temporada',
  episodes: 'Episodios',
  synopsis: 'Sinopsis',
  episode: 'Episodio',
  play: 'Reproducir',
  swipeToSeeMore: 'Desliza para ver más',
  myListAction: 'Mi lista',
  addToMyList: 'Añadir a favoritos',
  removeFromMyList: 'Eliminar de favoritos',
  popular: 'Popular',
  new: 'Nuevo',
  trending: 'Tendencia',
  highlight: 'Destacado',
  free: 'Gratis',
  premium: 'Premium',
  premiumEpisode: 'Episodio Premium',
  signInToUnlock: 'Inicia sesión para desbloquear',
  subscribeToWatch: 'Suscríbete para ver',

  // Profile
  subscribeToPremium: 'Pasar a Premium',
  subscribeWithDCB: 'Pasar a Premium con DCB',
  dcbSubscribeModalTitle: 'Suscripcion por pago movil',
  dcbSubscribeLoading: 'Preparando el pago...',
  dcbSubscribeError: 'No se pudo cargar la pagina de pago.',
  dcbSubscribeRetry: 'Reintentar',
  restorePurchases: 'Restaurar Compras',
  purchaseProcessing: 'Procesando...',
  subscriptionActivated: '¡Suscripción activada exitosamente!',
  webPaymentUnavailable: 'Los pagos web no están disponibles actualmente. Por favor, inténtelo de nuevo más tarde.',
  paymentInitializing: 'El sistema de pago se est\u00e1 inicializando. Por favor, int\u00e9ntalo de nuevo en unos segundos.',
  loadingOffers: 'Cargando ofertas...',
  purchasesRestored: '¡Tu suscripción ha sido restaurada exitosamente! Ahora tienes acceso a todo el contenido premium.',
  noPurchasesToRestore: 'No se encontraron suscripciones activas para restaurar. Si crees que esto es un error, por favor contacta con soporte.',
  purchaseFailed: 'Compra fallida. Por favor intenta de nuevo.',
  restoreFailed: 'Error al restaurar compras.',
  noActiveSubscription: 'No se encontró ninguna suscripción activa para restaurar.',
  iapNotAvailable: 'Las compras dentro de la aplicación no están disponibles.',
  webPurchaseNotSupported: 'Las compras dentro de la aplicación no están disponibles en la web. Por favor usa la aplicación móvil.',

  // Premium subscription paywall
  premiumSubscriptionTitle: 'Suscripción Premium Mensual',
  premiumSubscriptionTagline: 'Desbloquea acceso ilimitado a todas las series y episodios',
  whatYouGet: 'Lo Que Obtienes',

  // Profile subscription information
  profileSubscriptionDescription: 'Obtén acceso ilimitado a todas las series dramáticas y episodios con nuestra suscripción mensual.',
  profileBenefit1: 'Mira cualquier episodio de nuestra biblioteca completa',
  profileBenefit2: 'Acceso instantáneo a todos los nuevos episodios',
  profileBenefit3: 'Experiencia de visualización sin anuncios',

  premiumBenefit1: 'Acceso ilimitado a todas las series dramáticas - mira cualquier episodio, en cualquier momento',
  premiumBenefit2: 'Biblioteca completa de contenido actual con cientos de episodios',
  premiumBenefit3: 'Acceso instantáneo a todos los nuevos episodios cuando se estrenan',
  premiumBenefit4: 'Mira cualquier episodio sin restricciones ni limitaciones',
  premiumBenefit5: 'Experiencia de visualización sin anuncios para entretenimiento ininterrumpido',
  premiumBenefit6: 'Transmisión de vídeo de alta calidad para la mejor experiencia de visualización',
  premiumBenefit7: 'Acceso en todos tus dispositivos - teléfono, tableta y web',
  bestValue: 'Mejor Valor',
  subscriptionIncludes: 'Acceso completo a todo el contenido',
  perMonth: '/mes',
  perWeek: '/semana',
  startSubscription: 'Iniciar Suscripción',
  learnMoreAboutSubscription: 'Más Información Sobre la Suscripción',

  // Subscription terms
  subscriptionTerms: 'Se te cobrará a través de tu cuenta al precio mostrado en la pantalla de suscripción. La suscripción se renueva automáticamente cada mes a menos que la canceles al menos 24 horas antes de la fecha de renovación. Los cargos se realizan 24 horas antes del final de tu período de facturación actual.',

  // Subscription details modal
  subscriptionDetails: 'Detalles de la Suscripción',
  whatIsIncluded: 'Qué Está Incluido',
  subscriptionDetailsDescription: 'Tu suscripción Premium mensual te da acceso ilimitado a todas las series dramáticas y episodios en nuestra biblioteca. Esto incluye todo el contenido actual y todos los nuevos episodios que se estrenen durante tu período de suscripción. Puedes ver cualquier episodio, en cualquier momento, en cualquiera de tus dispositivos sin restricciones.',
  howBillingWorks: 'Cómo Funciona la Facturación',
  billingDescription: 'Se te cobrará a través de tu cuenta al precio mostrado en la pantalla de suscripción. La suscripción se renueva automáticamente cada mes a menos que la canceles al menos 24 horas antes de la fecha de renovación. Los cargos se realizan 24 horas antes del final de tu período de facturación actual.',
  howToCancel: 'Cómo Cancelar',
  cancellationDescription: 'Puedes cancelar tu suscripción en cualquier momento yendo a la configuración de tu dispositivo. Para iOS: Ajustes > [Tu Nombre] > Suscripciones. Para Android: Google Play Store > Menú > Suscripciones. Selecciona esta aplicación y toca Cancelar Suscripción. Tu suscripción permanece activa hasta el final del período de facturación actual.',
  cancellationDescriptionIos: 'Puedes cancelar tu suscripción en cualquier momento yendo a la configuración de tu dispositivo. Para iOS: Ajustes > [Tu Nombre] > Suscripciones. Selecciona esta aplicación y toca Cancelar Suscripción. Tu suscripción permanece activa hasta el final del período de facturación actual.',
  cancellationDescriptionAndroid: 'Puedes cancelar tu suscripción en cualquier momento yendo a la configuración de tu dispositivo. Para Android: Google Play Store > Menú > Suscripciones. Selecciona esta aplicación y toca Cancelar Suscripción. Tu suscripción permanece activa hasta el final del período de facturación actual.',
  subscriptionExpiry: 'Qué Sucede Cuando Expira la Suscripción',
  expiryDescription: 'Si cancelas o tu suscripción expira, perderás el acceso al contenido premium. Sin embargo, tu historial de visualización y favoritos se guardarán. Puedes volver a suscribirte en cualquier momento para recuperar el acceso completo a todos los episodios premium.',
  deviceCompatibility: 'Compatibilidad de Dispositivos',
  compatibilityDescription: 'Tu suscripción funciona en todas las plataformas donde uses la misma cuenta. Inicia sesión con la misma cuenta en cualquier dispositivo para acceder a tus beneficios premium.',
  helpFeedback: 'Ayuda y comentarios',
  language: 'Idioma',
  notifications: 'Notificaciones',
  notificationSettings: 'Configuración de notificaciones',
  pushNotifications: 'Notificaciones push',
  enabled: 'Activado',
  disabled: 'Desactivado',
  enable: 'Activar',
  enabling: 'Activando...',
  pushNotificationsEnabled: 'Notificaciones push activadas con éxito',
  pushNotificationsDisabled: 'Notificaciones push desactivadas',
  enablePushNotificationsInSettings: 'Para recibir notificaciones, actívalas en la configuración de tu dispositivo.',
  openSettings: 'Abrir configuración',
  pushNotificationsEnabledDescription: 'Recibirás notificaciones en este dispositivo',
  pushNotificationsDisabledDescription: 'Activa las notificaciones para mantenerte actualizado',
  notificationCategories: 'Categorías de notificaciones',
  notificationCategoriesDescription: 'Elige qué tipos de notificaciones deseas recibir',
  newEpisodes: 'Nuevos episodios',
  newEpisodesDescription: 'Recibe notificaciones cuando se publiquen nuevos episodios',
  recommendations: 'Recomendaciones',
  recommendationsDescription: 'Sugerencias de contenido personalizadas para ti',
  subscriptionReminders: 'Recordatorios de suscripción',
  subscriptionRemindersDescription: 'Recordatorios sobre el estado de tu suscripción',
  rewardsNotifications: 'Recompensas y logros',
  rewardsNotificationsDescription: 'Actualizaciones sobre tus recompensas y progreso',
  marketingNotifications: 'Marketing y promociones',
  marketingNotificationsDescription: 'Ofertas especiales y contenido promocional',
  failedToUpdatePreferences: 'Error al actualizar las preferencias de notificación',
  failedToRequestPermission: 'Error al solicitar permiso de notificación',
  signInToSavePreferences: 'Inicia sesión para guardar tus preferencias de notificación en todos tus dispositivos',
  done: 'Listo',
  contactUs: 'Contáctanos',
  settings: 'Configuración',
  privacyPolicy: 'Política de privacidad',
  privacySettings: 'Privacidad y Consentimiento',
  cookieSettings: 'Mi configuración de cookies',
  localStorage: 'Almacenamiento local',
  termsConditions: 'Términos y condiciones',
  legalNotice: 'Aviso legal',
  pricingConditions: 'Condiciones de precios',
  unsubscribe: 'Cancelar suscripción',
  unsubscribeInfo: 'Información de cancelación',
  loadingUnsubscribeInfo: 'Cargando información de cancelación...',
  unsubscribeContentNotAvailable: 'La información de cancelación no está disponible en este momento.',
  dcbUnsubscribeButton: 'Cancelar mi suscripción',
  dcbUnsubscribeConfirmTitle: 'Confirmación',
  dcbUnsubscribeConfirmMessage: '¿Estás seguro de que quieres cancelar tu suscripción? Perderás el acceso al contenido premium.',
  dcbUnsubscribeSuccess: 'Tu suscripción ha sido cancelada con éxito. Ya no estás suscrito al servicio.',
  dcbUnsubscribeError: 'No se pudo cancelar tu suscripción. Por favor, contacta al servicio de atención al cliente para obtener ayuda.',
  loadingPrivacyPolicy: 'Cargando política de privacidad...',
  privacyPolicyNotAvailable: 'La política de privacidad no está disponible en este momento.',
  loadingTermsConditions: 'Cargando términos y condiciones...',
  termsConditionsNotAvailable: 'Los términos y condiciones no están disponibles en este momento.',
  cookies: 'Cookies',
  cookiesSection: 'Cookies',
  legalSection: 'Informacion legal',
  loadingCookies: 'Cargando información de cookies...',
  cookiesNotAvailable: 'La información de cookies no está disponible en este momento.',
  loadingLegalNotice: 'Cargando aviso legal...',
  legalNoticeNotAvailable: 'El aviso legal no está disponible en este momento.',
  loadingPricingConditions: 'Cargando condiciones de precios...',
  pricingConditionsNotAvailable: 'Las condiciones de precios no están disponibles en este momento.',
  retry: 'Reintentar',
  noEmailApp: 'No hay ninguna aplicación de correo disponible en este dispositivo.',
  errorOpeningEmail: 'No se puede abrir la aplicación de correo.',
  errorOpeningSettings: 'No se puede abrir la configuración del sistema.',
  security: 'Seguridad',

  // Loading and errors
  loading: 'Cargando...',
  loadingContent: 'Cargando contenido...',
  preparingVideo: 'Preparando vídeo...',

  seasonNotFound: 'Temporada no encontrada',
  episodeNotFound: 'Episodio no encontrado',
  rubriqueNotFound: 'Sección no encontrada',

  // Video player

  loadingVideo: 'Cargando vídeo...',
  loadingPlayer: 'Cargando reproductor...',
  loadingEpisodes: 'Cargando episodios...',

  // Badges and labels
  min: 'min',
  enemiesToLovers: 'De enemigos a amantes',

  // Actions
  cancel: 'Cancelar',
  delete: 'Eliminar',
  remove: 'Quitar',
  removeFromList: 'Quitar de mi lista',
  subscribe: 'Suscribirse',
  selectLanguage: 'Seleccionar idioma',
  restartRequired: 'Reinicio requerido',
  restartMessage: 'Por favor, reinicie la aplicación para aplicar la nueva dirección de diseño.',
  restartToApplyLanguage: '¿Reiniciar la aplicación para aplicar el nuevo idioma?',
  ok: 'OK',
  save: 'Guardar',
  saving: 'Guardando...',
  editProfile: 'Editar perfil',
  pseudo: 'Seudónimo',
  enterPseudo: 'Ingrese su seudónimo',
  pseudoPlaceholder: 'Elija un nombre único (máx 16 car.)',
  pseudoTaken: 'Este seudónimo ya está en uso',
  pseudoInvalid: 'Este seudónimo contiene contenido inapropiado',
  pseudoInvalidCharacters: 'Este seudónimo contiene caracteres inválidos',
  pseudoNotAccepted: 'Por favor, elija otro seudónimo, este no puede ser aceptado',
  pseudoMaxLength: 'El seudónimo debe tener 16 caracteres como máximo',
  pseudoCharactersCount: '{{count}}/16 caracteres',
  editPseudo: 'Editar seudónimo',
  pseudoUpdated: 'Seudónimo actualizado exitosamente',
  subtitles: 'Subtítulos',
  off: 'Desactivado',
  noSubtitlesAvailable: 'No hay subtítulos disponibles',
  playbackSpeed: 'Velocidad de reproducción',
  normalSpeed: 'Normal',
  profileInformation: 'Información del perfil',
  dateOfBirth: 'Fecha de nacimiento',
  phoneNumber: 'Número de teléfono',
  enterPhoneNumber: 'Ingrese su número de teléfono',
  notProvided: 'No proporcionado',
  dateFormatHint: 'Formato: {format} (ej: {example})',
  dateFormatPattern: 'DD-MM-AAAA',
  dateFormatExample: '31-12-1990',
  invalidDateFormat: 'Por favor use el formato: {format}',
  invalidDate: 'Fecha inválida',

  // Placeholders and descriptions
  discoverGenre: 'Descubre',

  // Time and duration
  m: 'M', // Million views abbreviation
  now: 'ahora',
  minuteAbbrev: 'min',
  hourAbbrev: 'h',
  dayAbbrev: 'd',
  monthAbbrev: 'mes',

  // History and viewing progress
  noViewingHistory: 'Sin historial de visualización',
  episodesWillAppearHere: 'Los episodios que veas aparecerán aquí',
  history: 'Historial',
  series: 'Series',
  noFavoritesYet: 'Aún no hay favoritos',
  addContentToFavorites: 'Agrega series y episodios a tus favoritos para verlos aquí',

  // My Purchases
  myPurchases: 'Mis Compras',
  purchased: 'Comprado',
  myPurchasesTitle: 'Tus Episodios Desbloqueados',
  myPurchasesDescription: 'Encuentra aquí todos los episodios premium que has desbloqueado con tus monedas. ¡Sigue viendo para ganar más monedas!',
  tutorialStep1Title: 'Mira episodios',
  tutorialStep1Description: 'Gana monedas viendo contenido gratuito en la plataforma.',
  tutorialStep2Title: 'Acumula recompensas',
  tutorialStep2Description: 'Completa desafíos y conéctate diariamente para ganar aún más monedas.',
  tutorialStep3Title: 'Desbloquea contenido premium',
  tutorialStep3Description: 'Usa tus monedas para desbloquear episodios premium exclusivos.',
  goToRewards: 'Ver mis recompensas',

  // Gamification notifications
  userSignupNotification: '¡Bienvenido! ¡Ganaste {coins} monedas por crear tu cuenta!',
  dailyVisitNotification: '¡Ganaste {coins} monedas por tu visita diaria!',
  emailProvidedNotification: '¡Ganaste {coins} monedas por proporcionar tu correo!',
  msisdnProvidedNotification: '¡Ganaste {coins} monedas por proporcionar tu número de teléfono!',
  birthDateProvidedNotification: '¡Ganaste {coins} monedas por proporcionar tu fecha de nacimiento!',
  completeProfileNotification: '¡Ganaste {coins} monedas por completar tu perfil!',
  pseudoProvidedNotification: '¡Ganaste {coins} monedas por crear un seudónimo personalizado!',
  selectImageSource: 'Seleccionar fuente de imagen',
  takePhoto: 'Tomar foto',
  chooseFromLibrary: 'Elegir de la galería',
  removeProfilePicture: 'Eliminar foto de perfil',
  removeProfilePictureConfirm: '¿Estás seguro de que quieres eliminar tu foto de perfil?',
  profilePictureUpdated: 'Foto de perfil actualizada con éxito',
  profilePictureRemoved: 'Foto de perfil eliminada con éxito',
  failedToPickImage: 'Error al seleccionar imagen de la galería',
  failedToTakePhoto: 'Error al tomar foto',
  failedToUploadImage: 'Error al subir la imagen. Por favor, inténtalo de nuevo.',
  imageInappropriateContent: 'La imagen contiene contenido inapropiado',
  failedToUpdateProfilePicture: 'Error al actualizar la foto de perfil',
  failedToRemoveProfilePicture: 'Error al eliminar la foto de perfil',
  remove: 'Eliminar',
  watchEpisodeNotification: '¡Ganaste {coins} monedas por ver un episodio!',
  watchAdsNotification: '¡Ganaste {coins} monedas por ver anuncios!',
  enableNotificationsNotification: '¡Ganaste {coins} monedas por activar las notificaciones!',
  followSocialNotification: '¡Ganaste {coins} monedas por seguirnos en redes sociales!',
  coinsEarnedNotification: '¡Ganaste {coins} monedas!',
  coinsUsedForPremiumNotification: '¡Usaste {coins} monedas para desbloquear este episodio premium!',
  firstCoinsUsageNotification: '¡Bienvenido! ¡Acabas de desbloquear tu primer episodio premium con monedas!',

  // Reward Center
  rewardCenter: 'Centro de Recompensas',
  rewards: 'Recompensas',
  weeklyRanking: 'Clasificación Semanal',
  hallOfFame: 'Salón de la Fama',
  thisWeeksTopPlayers: 'Mejores Jugadores de Esta Semana',
  allTimeChampions: 'Campeones de Todos los Tiempos',
  totalCoinsAllTime: 'monedas en total',
  coinsThisWeek: 'monedas esta semana',
  achievements: 'logros',
  dayStreakRecord: 'racha de días',
  you: 'Tú',
  noRankingData: 'No hay datos de clasificación disponibles',
  checkBackLaterRanking: 'Vuelve más tarde para ver las clasificaciones semanales',
  noHallOfFameData: 'No hay datos del salón de la fama disponibles',
  checkBackLaterHallOfFame: 'Vuelve más tarde para ver las clasificaciones de todos los tiempos',
  coins: 'Monedas',
  days: 'días',
  dailyCheckIn: 'Check-in Diario',
  earnRewards: 'Ganar Recompensas',
  completed: 'Completado',
  claim: 'Por hacer',
  comingSoon: 'Próximamente',
  day: 'Día',
  today: 'Mañana',
  totalCoins: 'Total de Monedas',
  getCoins: 'Gana Monedas,',
  keepWatching: 'Sigue Viendo',
  dayStreak: 'Racha de Días',
  nextReward: 'Próxima recompensa',
  availableTomorrow: 'Disponible mañana',
  weekProgress: 'Progreso de la semana',
  serie: 'Racha',
  won: 'Ganado',
  tomorrow: 'Mañana',
  toDo: 'Por Hacer',
  firstWeek: 'Primera Semana',
  secondWeek: 'Segunda Semana',
  amazingStreak: '¡Racha increíble! ¡Sigue así!',
  overallProgress: 'Progreso General',
  of: 'de',
  eventsCompleted: 'eventos completados',
  ofMissionsCompleted: 'de misiones completadas',

  // Gamification event categories
  gamificationCategoryUser: 'Usuario',
  gamificationCategoryProfile: 'Perfil',
  gamificationCategoryContent: 'Contenido',
  gamificationCategoryGeneral: 'General',
  gamificationCategoryDailyMission: 'Misión diaria',
  gamificationCategoryWelcomeMissions: 'Misiones de bienvenida',
  gamificationCategoryWatchMissions: 'Misiones de visualización',
  gamificationCategoryOnceAYear: 'Una vez al año',

  // Gamification Intro Modal (for guests)
  gamificationIntroSubtitle: 'Completa misiones y gana monedas!',
  gamificationFeature1Title: 'Crear tu cuenta',
  gamificationFeature1Desc: 'Recibe {{coins}} monedas de bienvenida al registrarte',
  gamificationFeature2Title: 'Mira episodios',
  gamificationFeature2Desc: 'Gana {{coins}} monedas por cada episodio que completes',
  gamificationFeature3Title: 'Sube en el ranking',
  gamificationFeature3Desc: 'Comparate con otros miembros cada semana',
  gamificationFeature4Title: 'Desbloquea episodios premium',
  gamificationFeature4Desc: 'Usa tus monedas para ver aun mas episodios',
  gamificationBonusText: '+{{coins}} monedas gratis al registrarte!',
  createAccount: 'Crear mi cuenta',
  connectToYou: 'Conectate',

  // All Episodes Control
  allEpisodes: 'Todos los episodios',
  watchNow: 'Ver ahora',
  previousEpisode: 'Anterior',
  nextEpisode: 'Siguiente',

  // App availability
  appNotAvailable: 'Esta aplicación aún no está disponible en tu país e idioma.',
  appNotAvailableSubtext: 'Estamos trabajando para expandir nuestro servicio a más regiones.',

  // Biometric authentication
  biometricLogin: 'Inicio de Sesión Biométrico',
  signInWithBiometric: 'Iniciar sesión con biometría',
  signInWithWebAuthn: 'Iniciar sesión con WebAuthn',
  signInWithFaceId: 'Iniciar sesión con Face ID',
  signInWithTouchId: 'Iniciar sesión con Touch ID',
  enableBiometric: 'Activar inicio de sesión biométrico',
  disableBiometric: 'Desactivar inicio de sesión biométrico',
  biometricNotAvailable: 'La autenticación biométrica no está disponible en este dispositivo',
  biometricAuthFailed: 'La autenticación biométrica falló',
  biometricDataMissing: 'Los datos de inicio de sesión biométrico faltan. Por favor inicia sesión con OTP, luego reactiva el inicio de sesión biométrico en la configuración de tu perfil.',
  biometricNoUserData: 'Por favor inicia sesión primero, luego activa el inicio de sesión biométrico en la configuración de tu perfil.',
  biometricUnexpectedError: 'Ocurrió un error inesperado. Por favor inicia sesión con OTP, luego reactiva el inicio de sesión biométrico en la configuración de tu perfil.',
  biometricAuthCancelled: 'La autenticación biométrica fue cancelada. Por favor intenta de nuevo.',
  webauthnNotEnabled: 'Por favor inicia sesión primero, luego activa el inicio de sesión WebAuthn en la configuración de tu perfil.',
  webauthnCancelled: 'La autenticación WebAuthn fue cancelada. Por favor intenta de nuevo.',
  webauthnFailed: 'La autenticación WebAuthn falló',
  biometricLoginEnabled: 'El inicio de sesión biométrico ha sido activado',
  biometricLoginDisabled: 'El inicio de sesión biométrico ha sido desactivado',
  webauthnLoginEnabled: 'El inicio de sesión WebAuthn ha sido activado',
  webauthnLoginDisabled: 'El inicio de sesión WebAuthn ha sido desactivado',
  // iOS-specific labels (use branded terminology)
  faceIdLoginEnabled: 'El inicio de sesión Face ID ha sido activado',
  faceIdLoginDisabled: 'El inicio de sesión Face ID ha sido desactivado',
  touchIdLoginEnabled: 'El inicio de sesión Touch ID ha sido activado',
  touchIdLoginDisabled: 'El inicio de sesión Touch ID ha sido desactivado',
  // Android-specific labels (use generic biometric terminology)
  androidBiometricLoginEnabled: 'El inicio de sesión biométrico ha sido activado',
  androidBiometricLoginDisabled: 'El inicio de sesión biométrico ha sido desactivado',
  failedToEnableBiometric: 'Error al activar el inicio de sesión biométrico',
  failedToDisableBiometric: 'Error al desactivar el inicio de sesión biométrico',
  failedToEnableWebauthn: 'Error al activar el inicio de sesión WebAuthn',
  failedToDisableWebauthn: 'Error al desactivar el inicio de sesión WebAuthn',
  success: 'Éxito',
  enableBiometricPrompt: '¿Activar la autenticación biométrica para un inicio de sesión rápido la próxima vez?',
  enableBiometricPromptIos: '¿Activar {authType} para un inicio de sesión rápido la próxima vez?',
  'Enable {{authType}}?': '¿Activar {{authType}}?',
  'Would you like to enable {{authType}} for faster login?': '¿Te gustaría activar {{authType}} para un inicio de sesión más rápido?',
  '{{authType}} login has been enabled!': '¡El inicio de sesión {{authType}} ha sido activado!',
  'Failed to enable {{authType}} login. Please try again later.': 'Error al activar el inicio de sesión {{authType}}. Por favor intenta más tarde.',
  biometricLoginTitle: 'Inicio de Sesión Biométrico',
  faceIdLogin: 'Inicio de Sesión Face ID',
  touchIdLogin: 'Inicio de Sesión Touch ID',
  useBiometricToSignIn: 'Usa huella digital o reconocimiento facial para iniciar sesión rápidamente',
  enableBiometricForSignIn: 'Activa huella digital o reconocimiento facial para un inicio de sesión rápido',
  useFaceIdToSignIn: 'Usa Face ID para iniciar sesión rápidamente',
  enableFaceIdForSignIn: 'Activa Face ID para un inicio de sesión rápido',
  useTouchIdToSignIn: 'Usa Touch ID para iniciar sesión rápidamente',
  enableTouchIdForSignIn: 'Activa Touch ID para un inicio de sesión rápido',

  // Delete account
  deleteMyAccount: 'Eliminar mi cuenta',
  deleteAccountConfirmation: 'Confirmación de eliminación',
  deleteAccountWarningNotSubscribed: 'Procederemos con la eliminación de su cuenta. Ya no podrá acceder a Hekaya después de confirmar.\n\nSin embargo, tenga en cuenta que de conformidad con la normativa, conservamos de forma segura ciertos datos, por ejemplo, para posibles fines de resolución de disputas.',
  deleteAccountWarningSubscribed: 'Actualmente tiene una suscripción activa. Por favor cancélela primero. Encontrará las instrucciones de cancelación en "Mi cuenta", "Cancelar suscripción". Una vez cancelada la suscripción, podrá proceder con la eliminación de su cuenta.\n\nProcederemos con la eliminación de su cuenta. Ya no podrá acceder a Hekaya después de confirmar.\n\nSin embargo, tenga en cuenta que de conformidad con la normativa, conservamos de forma segura ciertos datos, por ejemplo, para posibles fines de resolución de disputas.',
  iConfirm: 'Confirmo',
  deletingAccount: 'Eliminando cuenta...',
  accountDeleted: 'Cuenta eliminada',
  accountDeletedSuccess: 'Su cuenta ha sido eliminada con éxito',
  accountDeleteError: 'Error al eliminar la cuenta',
  activeSubscriptionErrorTitle: 'Suscripcion activa',
  activeSubscriptionErrorMessage: 'Debe cancelar su suscripcion antes de poder eliminar su cuenta.',
  gracePeriodErrorTitle: 'Eliminacion no disponible por ahora',
  gracePeriodErrorMessage: 'Su suscripcion ha sido cancelada, pero sigue activa hasta su fecha de vencimiento. Podra eliminar su cuenta una vez finalizado este periodo.',
  gracePeriodBannerTitle: 'Suscripcion cancelada',
  gracePeriodBannerMessage: 'Su suscripcion ha sido cancelada pero sigue activa hasta el {{date}}. Conserva el acceso a todo el contenido premium hasta esa fecha.',
  notBilledDenyBannerTitle: 'Suscripcion suspendida',
  notBilledDenyBannerMessage: 'Su suscripcion ha sido suspendida temporalmente debido a un problema de pago. Para restablecer el acceso a nuestro servicio, recargue su cuenta *9. Su cuenta Hekaya se reactivara una vez procesado el pago.',

  // Network connection
  noInternetConnection: 'No hay conexión a internet disponible. Por favor verifica tu conexión e intenta de nuevo.',
  noInternetConnectionShort: 'Sin conexión a internet',
  checkInternetConnection: 'Por favor verifica tu conexión a internet',
  connectionRequired: 'Se requiere conexión a internet',
  dismiss: 'Continuar sin conexión',
  slowNetworkDetected: 'Red lenta detectada',
  poorNetworkConnection: 'Tu conexión de red está experimentando problemas. La carga del video está tardando más de lo normal.',
  loadingTime: 'Tiempo de carga',
  slowConnection: 'Conexión lenta',
  retry: 'Reintentar',

  // Image Cache Storage
  imageCacheStorage: 'Almacenamiento de caché de imágenes',
  cachedImages: 'Imágenes en caché',
  storageUsed: 'Almacenamiento usado',
  expiredImages: 'Imágenes caducadas',
  clearExpiredCache: 'Borrar caducadas',
  clearAllCache: 'Borrar todo',
  clearing: 'Borrando...',
  clearImageCache: 'Borrar caché de imágenes',
  clearImageCacheConfirmation: '¿Estás seguro de que quieres borrar todas las imágenes en caché? Esto liberará espacio de almacenamiento pero las imágenes deberán descargarse de nuevo.',
  clearCache: 'Borrar caché',
  cacheCleared: '¡Caché borrada con éxito! {{count}} imágenes eliminadas.',
  expiredCacheCleared: '¡Caché caducada borrada! {{count}} imágenes caducadas eliminadas.',
  noExpiredCache: 'No hay imágenes caducadas que borrar.',
  failedToClearCache: 'Error al borrar la caché. Por favor, inténtalo de nuevo.',
  cacheAutoClears30Days: 'Las imágenes se eliminan automáticamente después de 30 días',
  info: 'Info',

  // App version
  version: 'Versión',

  // Pagination
  scrollForMore: 'Desliza para ver mas',
  noMoreContent: 'Fin de la lista',
  loadingMore: 'Cargando...',

  // OTP Authentication
  otp: {
    signInOrSignUp: 'Inicia sesión o crea una cuenta gratis',
    subscriptionWelcomeTitle: 'Gracias por tu suscripcion!',
    subscriptionWelcomeMessage: 'Ultimo paso: registrate para crear una cuenta o inicia sesion en una existente para empezar a ver dramas.',
    emailPlaceholder: 'Direccion de correo electronico',
    phonePlaceholder: 'Numero de telefono',
    emailOrPhonePlaceholder: 'Email o Numero de telefono',
    continue: 'Continuar',
    continueWithGoogle: 'Continuar con Google',
    continueWithApple: 'Continuar con Apple',
    termsPrefix: 'Al continuar, aceptas nuestros',
    termsOfService: 'Terminos de servicio',
    privacyPolicy: 'Politica de privacidad',
    confirmEmail: 'Confirmar direccion de correo',
    confirmYourEmail: 'Confirma tu direccion de correo electronico',
    confirmPhone: 'Confirmar numero de telefono',
    confirmYourPhone: 'Confirma tu numero de telefono',
    codeSentTo: 'Enviamos un codigo a',
    codeSentToPhone: 'Enviamos un codigo al',
    enterCodeBelow: 'Ingresalo a continuacion para verificar tu cuenta.',
    resendCode: 'Reenviar codigo',
    resendIn: 'Reenviar en',
    verify: 'Verificar',
    connectingInProgress: 'Conectando...',
    accountCreated: 'Cuenta creada',
    stayUpdatedTitle: '¿Te gustaria estar al tanto de las ultimas novedades?',
    stayUpdatedDescription: 'Nos encantaria enviarte ofertas personalizadas, contenido inspirador, consejos sobre dispositivos e informacion sobre nuestras ultimas innovaciones.',
    learnMore: 'Saber mas',
    subscribe: 'Suscribirse',
    noThanks: 'No gracias',
    enterEmailOrPhone: 'Por favor ingresa tu correo electronico o numero de telefono',
    sendFailed: 'Error al enviar el codigo. Por favor intenta de nuevo.',
    enterCompleteCode: 'Por favor ingresa el codigo completo de 6 digitos',
    verificationFailed: 'La verificacion fallo. Por favor intenta de nuevo.',
    invalidCode: 'Codigo invalido. Por favor intenta de nuevo.',
    codeExpired: 'El codigo ha expirado. Por favor solicita uno nuevo.',
    checkSpamFolder: 'Recuerda revisar tu carpeta de correo no deseado',
    dcbValidatingSubscription: 'Validando tu suscripcion...',
    dcbActivating: 'Activando tu suscripcion...',
    dcbSuccessTitle: 'Suscripcion activada!',
    dcbSuccessMessage: 'Tu suscripcion ha sido activada con exito. Ahora puedes disfrutar de todo el contenido.',
    dcbStartWatching: 'Empezar a ver',
    dcbErrorTitle: 'Error de activacion',
    dcbErrorRetry: 'Ocurrio un error al activar tu suscripcion. Por favor intenta de nuevo.',
    dcbPaymentNotFound: 'Suscripcion no encontrada. Verifica tu enlace o contacta al soporte.',
    dcbRetryButton: 'Reintentar',
    dcbIdentityMismatchPhone: 'El numero utilizado para la suscripcion es {{identifier}}. Por favor usa este numero para crear tu cuenta.',
    dcbIdentityMismatchEmail: 'El email utilizado para la suscripcion es {{identifier}}. Por favor usa este email para crear tu cuenta.',
    dcbRecoveryBanner: 'Se ha detectado una suscripcion pendiente. Crea tu cuenta para acceder.',
    dcbAlreadySubscribed: 'Ya suscrito mediante pago movil?',
    dcbEnterPhone: 'Ingresa el numero de telefono utilizado durante el pago:',
    dcbRecoverButton: 'Recuperar',
    dcbMsisdnNotFound: 'No se encontro suscripcion pendiente para este numero.',
    dcbMsisdnRecoveryFailed: 'Error al recuperar. Por favor reintenta.',
    invalidPhoneNumber: 'Numero de telefono invalido.',
  },
  and: 'y',
  smartBannerSubtitle: 'Mejor experiencia en la app',
  smartBannerOpen: 'ABRIR',
  paymentVerifying: 'Verificando tu suscripci\u00f3n...',
  paymentSuccessTitle: '\u00a1Suscripci\u00f3n activada!',
  paymentSuccessMessage: 'Felicidades, ahora tienes acceso a todo el contenido Premium.',
  paymentSuccessButton: 'Empezar a ver',
  paymentPendingMessage: 'Tu pago ha sido recibido. Tu suscripci\u00f3n estar\u00e1 activa en unos momentos.',
  paymentRefreshButton: 'Actualizar',
  redirectingToPayment: 'Redirigiendo a la p\u00e1gina de pago...',
  webPaymentIframeErrorTitle: 'P\u00e1gina de pago no disponible',
  webPaymentIframeErrorMessage: 'La p\u00e1gina de pago no se pudo cargar en la aplicaci\u00f3n. Puedes abrirla en una nueva pesta\u00f1a.',
  webPaymentOpenExternal: 'Abrir en una nueva pesta\u00f1a',

  // Premium subscription card
  enterPremiumExperience: 'Entra en la experiencia',
  popular: 'POPULAR',
  mobileInvoice: 'Factura M\u00f3vil',
  mobileInvoicePrice: '\u20ac9,99/mes',
  mobileInvoiceDescription: 'Pago en tu factura telef\u00f3nica. Simple y R\u00e1pido.',
  cardAppleGooglePay: 'Tarjeta / Apple Pay / Google Pay',
  cardPaymentDescription: 'Pago seguro con tarjeta, Apple Pay o Google Pay.',
  dcbPaymentOfferDescription: 'Pago en tu factura telefonica. Simple y rapido.',
  appStorePaymentTitle: 'App Store',
  appStorePaymentDescription: 'Suscripci\u00f3n facturada y gestionada a trav\u00e9s de tu cuenta de Apple App Store.',
  playStorePaymentTitle: 'Google Play',
  playStorePaymentDescription: 'Suscripci\u00f3n facturada y gestionada a trav\u00e9s de tu cuenta de Google Play Store.',
  upgradeToPremium: 'Pasar a Premium',
  cancelAnytimeNoCommitment: 'Cancela en cualquier momento \u00b7 Sin compromiso',
  whyBecomeVip: '\u00bfPor qu\u00e9 ser VIP?',
  joinPremiumCommunity: '\u00danete a nuestra comunidad Premium Hekaya',
  unlimitedAccessShort: 'Accede sin l\u00edmites a todas las series y episodios.\nMira cuando quieras, donde quieras.',
};
